var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"ml-3 mr-4 remove_clone",attrs:{"small":_vm.small,"dark":"","color":_vm.scoreColor(_vm.score)}},on),[_vm._v(_vm._s(_vm.score))])]}}])},[_c('span',[_vm._v("Score")])])}
var staticRenderFns = []

export { render, staticRenderFns }